// src/stores/appStore.js
import { defineStore } from "pinia";
import { toast } from "vue3-toastify";

export const useAppStore = defineStore("appStore", {
  state: () => ({
    isLoading: false,
    notifications: [],
    sidebarOpen: true,
    theme: 'light'
  }),

  actions: {
    setLoading(state) {
      this.isLoading = state;
    },

    setToggleSidebar() {
      (sidebarOpen.value = !sidebarOpen.value);
    },

    setTheme() {
      (theme.value = theme.value === 'light' ? 'dark' : 'light');
    },

    setNotification(notification) {
      // Adiciona notificação ao array e exibe com o Toastify
      this.notifications.push(notification);
      toast[notification.type](notification.message);

      // Opcional: Limite de notificações no estado
      if (this.notifications.length > 10) {
        this.notifications.shift();
      }
    },
  },
});
